module.exports = __webpack_public_path__ + "7d088296/img/dollar-icon.35c9d638.svg";